maybeEnqueue_1